import store from '@/stores/store'
import { getAppDisplayName } from '@/appDisplayNames'

const CmFrotas = () => import(/* webpackChunkName: "cm-frotas" */ '@/components/cm-frotas.vue')
const Index = () => import(/* webpackChunkName: "cm-frotas" */ '@/components/cm-frotas/Index')
const Consult = () => import(/* webpackChunkName: "cm-frotas" */ '@/components/cm-frotas/Consult')
const Show = () => import(/* webpackChunkName: "cm-frotas" */ '@/components/cm-frotas/Show')
const Setting = () => import(/* webpackChunkName: "cm-frotas" */ '@/components/cm-frotas/Setting')

const getAppName = () => getAppDisplayName('cm-frotas', store.getters.getPartner)

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [{ dynamicName: getAppName }]
      },
      path: '/'
    },
    {
      component: Consult,
      meta: {
        breadcrumbs: [
          { link: '/cm-frotas', dynamicName: getAppName },
          { name: 'Históricos de Consultas' },
        ]
      },
      path: 'consultas'
    },
    {
      component: Setting,
      meta: {
        breadcrumbs: [
          { link: '/cm-frotas', dynamicName: getAppName },
          { name: 'Configurações' },
        ]
      },
      path: 'configuracoes'
    },
    {
      component: Show,
      meta: {
        breadcrumbs: [
          { link: '/cm-frotas', dynamicName: getAppName },
          { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
        ]
      },
      path: 'multas/:id',
      props: true
    }
  ],
  component: CmFrotas,
  path: 'cm-frotas'
}
